<template>
  <section class="panel">
    <h2>Ferramentas do agente</h2>
    <p class="muted">Capacidades registradas no backend, com categoria de risco e política de aprovação.</p>
    <ul class="plain">
      <li v-for="tool in tools" :key="tool.name">
        <strong>{{ tool.name }}</strong>
        <span class="muted"> · risco {{ tool.riskCategory }}</span>
        <span class="muted" v-if="tool.requiresApproval"> · exige aprovação</span>
        <p class="muted">{{ tool.description }}</p>
      </li>
    </ul>
    <p class="muted" v-if="error">{{ error }}</p>
  </section>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue';

type ToolInfo = {
  name: string;
  description: string;
  riskCategory: string;
  requiresApproval: boolean;
};

const tools = ref<ToolInfo[]>([]);
const error = ref('');

onMounted(async () => {
  try {
    const res = await fetch('/api/tools', { credentials: 'include' });
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    const data = (await res.json()) as { tools: ToolInfo[] };
    tools.value = data.tools ?? [];
  } catch (err) {
    error.value = err instanceof Error ? err.message : 'Falha ao carregar ferramentas';
  }
});
</script>
